import { AuthLayout, RegisterForm } from 'src/features/auth/components';

const Register = () => {
    return (
        <AuthLayout>
            <RegisterForm />
        </AuthLayout>
    );
};

export { Register };
